class TokenService {
  storageKey = 'auth_token';
  getToken() {
    return localStorage.getItem(this.storageKey);
  }
  saveToken(token: string) {
    localStorage.setItem(this.storageKey, token);
  }
  removeToken() {
    localStorage.removeItem(this.storageKey);
  }
  getTokenPayload() {
    const token = this.getToken() || '';
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return {};
    }
  }
}

export const tokenService = new TokenService();
